import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { CustomAccordion } from '../../../../ui/molecules/accordion'
import { Calendar } from '../../../../ui/molecules/calendar'
import { MadfarmInput } from '../../../../ui/molecules/input/newInput'
import { ProtocolSearch } from '../../../../ui/molecules/ProtocolSearch'
import { MadfarmStaticSelect } from '../../../../ui/molecules/select/newSelect/static'
import TextArea from '../../../../ui/molecules/textArea'
import { ReportingStatusOption, ReportingTypologyOption } from '../../../../utils'
import { setReportingCustomerOtherODC, setReportingDetails, setReportingEntryProtocolId, setReportingNote, setReportingReportingDate, setReportingReportingState, setReportingReportingType, setReportingSender, setUpdateReportingCustomerOtherODC, setUpdateReportingDetails, setUpdateReportingEntryProtocolId, setUpdateReportingNote, setUpdateReportingReportingDate, setUpdateReportingReportingState, setUpdateReportingReportingType, setUpdateReportingSender } from '../slice'
import '../styles.scss'
import { useState } from 'react'

export function AddReportingForms() {
    const dispatch = useAppDispatch()
    const reportingState = useAppSelector(state => state.reporting)
    const [expanded, setExpanded] = useState<string>('panel1')

    const currentRequest = !reportingState.fromCreationToUpdate
        ? reportingState.reportingCreationRequest
        : reportingState.reportingUpdateRequest

    const handleToggleAccordion = (panelId: string) => {
        setExpanded((prevExpanded) => (prevExpanded === panelId ? '' : panelId))
    }

    return (
        <div className="p-6 flex flex-col gap-6">
            <CustomAccordion
                id="panel1"
                title={<span className="text-uppercase text-white label-input">Segnalazione</span>}
                expanded={expanded === 'panel1'}
                onChange={() => handleToggleAccordion('panel1')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className="grid grid-cols-3 gap-4 items-start">
                    <div className="w-full">
                        <span className="text-left text-label-md font-semibold text-brandPrimary-800 block">Data<span className="text-red-500"> *</span></span>
                        <Calendar
                            errorLabel={reportingState.reportingErrors.reportingDate ? 'Data mancante' : undefined}
                            selected={currentRequest.reportingDate}
                            onChange={(date) => !reportingState.fromCreationToUpdate
                                ? dispatch(setReportingReportingDate(date))
                                : dispatch(setUpdateReportingReportingDate(date))
                            }
                        />
                    </div>

                    <MadfarmInput
                        required
                        label="Mittente"
                        error={reportingState.reportingErrors.sender}
                        supportingText={reportingState.reportingErrors.sender ? 'Mittente mancante' : undefined}
                        placeholder="Specifica mittente..."
                        value={currentRequest.sender}
                        onChangeText={(text) => !reportingState.fromCreationToUpdate
                            ? dispatch(setReportingSender(text))
                            : dispatch(setUpdateReportingSender(text))}
                    />

                    <MadfarmInput
                        label="Cliente Altro ODC"
                        placeholder="Specifica cliente..."
                        value={currentRequest.customerOtherODC}
                        onChangeText={(text) => !reportingState.fromCreationToUpdate
                            ? dispatch(setReportingCustomerOtherODC(text))
                            : dispatch(setUpdateReportingCustomerOtherODC(text))}
                    />
                </div>

                <div className="grid grid-cols-2 gap-4 items-start">
                    <MadfarmStaticSelect
                        required
                        label="Tipologia"
                        error={reportingState.reportingErrors.reportingType}
                        errorLabel="Tipologia mancante"
                        placeholder={'Seleziona tipologia...'}
                        options={ReportingTypologyOption}
                        value={currentRequest.reportingType}
                        noOptionsMessage="Nessuna tipologia trovata"
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            !reportingState.fromCreationToUpdate
                                ? dispatch(setReportingReportingType(newValue))
                                : dispatch(setUpdateReportingReportingType(newValue))
                        }}
                    />

                    <MadfarmStaticSelect
                        required
                        label="Stato"
                        error={reportingState.reportingErrors.reportingState}
                        errorLabel="Stato mancante"
                        placeholder={'Seleziona stato...'}
                        options={ReportingStatusOption}
                        value={currentRequest.reportingState}
                        noOptionsMessage="Nessuno stato trovato"
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            !reportingState.fromCreationToUpdate
                                ? dispatch(setReportingReportingState(newValue))
                                : dispatch(setUpdateReportingReportingState(newValue))
                        }}
                    />
                </div>

                <div className="grid grid-cols-1 gap-4">
                    <ProtocolSearch
                        errorLabel={reportingState.reportingErrors.entryProtocolId ? 'Protocollo mancante' : undefined}
                        type='entry'
                        value={currentRequest.entryProtocolId}
                        onSelect={(value) => !reportingState.fromCreationToUpdate
                            ? dispatch(setReportingEntryProtocolId(value))
                            : dispatch(setUpdateReportingEntryProtocolId(value))}
                    />
                </div>
            </CustomAccordion>

            <CustomAccordion
                id="panel2"
                title={<span className="text-uppercase text-white label-input">Dettagli</span>}
                expanded={expanded === 'panel2'}
                onChange={() => handleToggleAccordion('panel2')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className="w-full text-left text-label-md font-semibold text-brandPrimary-800">
                    Dettagli della segnalazione<span className="text-red-500"> *</span>
                </div>
                <TextArea
                    error={reportingState.reportingErrors.details}
                    supportingText={reportingState.reportingErrors.details ? 'Dettagli mancanti' : undefined}
                    placeholder="Specificare i dettagli della segnalazione..."
                    value={currentRequest.details}
                    onChangeText={(text) => !reportingState.fromCreationToUpdate
                        ? dispatch(setReportingDetails(text))
                        : dispatch(setUpdateReportingDetails(text))}
                />

                <div className="w-full text-left text-label-md font-semibold text-brandPrimary-800">
                    Note
                </div>
                <TextArea
                    value={currentRequest.note}
                    onChangeText={(text) => !reportingState.fromCreationToUpdate
                        ? dispatch(setReportingNote(text))
                        : dispatch(setUpdateReportingNote(text))}
                />
            </CustomAccordion>
        </div>
    )
}